<template>
  <div class="btnbox">
    <button @click="_change(item.key)" :class="index == item.key ? 'active' : ''" v-for="item in list" :key="item.key">{{item.value}}</button>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      index: '',
    };
  },
  methods: {
    _change(index) {
      this.index = index;
      this.$emit('_fromType', index);
    },
  },
};
</script>

<style scoped>
.btnbox {
  margin-bottom: 28px;
}
button {
  width: 80px;
  text-align: center;
  height: 32px;
  line-height: 32px;
  border: none;
  background-color: rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  color: rgba(4, 4, 4, 0.64);
  font-size: 14px;
  cursor: pointer;
}
button:not(:first-child) {
  margin-left: 24px;
}
.active {
  background-color: #2f98e9;
  color: #fff;
}
</style>
